import type { ChildColor } from "../_data/mock";

const colorMap: Record<
  ChildColor,
  { ring: string; track: string; text: string }
> = {
  orange: {
    ring: "stroke-[var(--child-1-primary)]",
    track: "stroke-[var(--child-1-track)]",
    text: "text-[var(--child-1-primary)]",
  },
  blue: {
    ring: "stroke-[var(--child-2-primary)]",
    track: "stroke-[var(--child-2-track)]",
    text: "text-[var(--child-2-primary)]",
  },
};

export function ProgressRing({
  progress,
  tone,
  label,
  sublabel,
  size = 76,
}: {
  progress: number;
  tone: ChildColor;
  label: string;
  sublabel: string;
  size?: number;
}) {
  const strokeWidth = 7;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference * (1 - Math.max(0, Math.min(1, progress)));
  const c = colorMap[tone];

  return (
    <div className="flex flex-col items-center gap-1">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            fill="none"
            className={c.track}
          />
          <circle
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            fill="none"
            strokeLinecap="round"
            strokeDasharray={circumference}
            strokeDashoffset={offset}
            className={c.ring}
          />
        </svg>
        <div className="absolute inset-0 flex flex-col items-center justify-center">
          <span className={`text-sm font-bold ${c.text}`}>{label}</span>
        </div>
      </div>
      <span className="text-[11px] font-semibold text-[var(--text-2)]">
        {sublabel}
      </span>
    </div>
  );
}
